import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'shards-react';
import SwitchNotification from './SwitchNotification';
import SelectCustomers from './SelectCustomers';
import useLocales from '../../../hooks/useLocales';
import { useTranslation } from 'react-i18next';
import { useCustomerOptions } from '../../../hooks/user-info/useCustomerOptions';
import { useDispatch } from '../../../redux/store';
import { updateNotification } from '../../../redux/slices/ownInfo';
import { LANGUAGE } from '../../../constants';
import type { OptionsType } from '../../../types/options';
import type { UpdateNotificationParams } from '../../../types/ownInfo';
import type { OrganizationUserType } from '../../../types/user';
import ErrorCustomerOptions from './ErrorCustomerOptions';

interface MailNotificationProps {
  organizationUser: OrganizationUserType;
}

const MailNotificationItem = React.memo(({ organizationUser }: MailNotificationProps): React.ReactElement => {
  const { id, organizationId, organizationBaseName, organizationSuffixName, tradingCompanyNameJa, tradingCompanyNameEn, emailNotificationFlag, emailNotificationCustomers } = organizationUser;
  const { t } = useTranslation();
  const { currentLang } = useLocales();
  const dispatch = useDispatch();
  const { options, getCustomerOptions, hasError, message, resetMessage } = useCustomerOptions();
  const [selectedCustomers, setSelectedCustomers] = useState<OptionsType[]>([]);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (options.length === 0) {
      getCustomerOptions(organizationId);
    } else {
      // do nothing
    }
  }, []);

  // emailNotificationCustomersをOptionsTypeに変換
  useEffect(() => {
    if (options.length > 0) {
      const selectedOptions: OptionsType[] = emailNotificationCustomers.map((org) => {
        const targetOption: OptionsType | undefined = options.find((option) => option.code === org);
        if (targetOption) {
          return targetOption;
        } else {
          return;
        }
      });
      setSelectedCustomers(selectedOptions);
    } else {
      // do nothing
    }
  }, [emailNotificationCustomers, options]);

  // EVENT HANDLER
  // ================================================================================

  // const handleSwitchNotification = useCallback(
  //   (event: React.ChangeEvent<HTMLInputElement>): void => {
  //     const checked: boolean = event.currentTarget.checked;
  //     const params: UpdateNotificationParams = { id, emailNotificationFlag: checked };
  //     dispatch(updateNotification(params));
  //   },
  //   [id],
  // );

  const handleSwitchNotification = useCallback(
    (event: React.MouseEvent<HTMLDivElement>): void => {
      const params: UpdateNotificationParams = { id, emailNotificationFlag: !emailNotificationFlag };
      dispatch(updateNotification(params));
    },
    [id, emailNotificationFlag],
  );

  const handleChangeCustomer = useCallback(
    (options: OptionsType[]): void => {
      setSelectedCustomers(options);
      const customers: string[] = options.map((option) => option.code);
      const params: UpdateNotificationParams = { id, emailNotificationCustomers: customers };
      dispatch(updateNotification(params));
    },
    [id],
  );

  // VIEW
  // ================================================================================

  return (
    <div className="organization-user-item my-4">
      <Row form>
        <Col md={2}>
          {organizationBaseName + ' ' + organizationSuffixName}
          <br />
          {'（' + (currentLang.value === LANGUAGE.JA ? tradingCompanyNameJa : tradingCompanyNameEn) + '）'}
        </Col>
        <Col>
          <SwitchNotification notificationFlag={emailNotificationFlag} onSwitchNotification={handleSwitchNotification} />
        </Col>
      </Row>
      <Row form>
        <Col md={2}>{t('user.emailRefinement')}</Col>
        <Col>
          <SelectCustomers selectedCustomers={selectedCustomers} options={options} onChangeCustomer={handleChangeCustomer} />
        </Col>
        <Col md={2}>{hasError ? <ErrorCustomerOptions message={message} resetMessage={resetMessage} /> : <></>}</Col>
      </Row>
    </div>
  );
});

MailNotificationItem.displayName = 'MailNotificationItem';
export default MailNotificationItem;
